export const COMPANY_LIST = 'COMPANY_LIST'
